// components/LoaderOverlay.js
import React from 'react';
import { Spinner } from 'react-bootstrap';

const LoaderOverlay = ({ loading }) => {
  if (!loading) return null;

  return (
    <div
      className="loader-overlay"
      style={{
        position: 'fixed', // or 'absolute' if needed within a container
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(255, 255, 255, 0.7)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
      }}
    >
      <Spinner animation="border" variant="primary" />
    </div>
  );
};

export default LoaderOverlay;
